import type { Rich } from "../lib/eam";

/** Copy from `eam.ts` with its bold runs. */
export default function RichText({ parts }: { parts: Rich }) {
  return (
    <>
      {parts.map((part, i) => (typeof part === "string" ? part : <b key={i}>{part.b}</b>))}
    </>
  );
}
